import { render, staticRenderFns } from "./SimulationInfo.vue?vue&type=template&id=1c2f4cb7&scoped=true"
import script from "./SimulationInfo.vue?vue&type=script&lang=js"
export * from "./SimulationInfo.vue?vue&type=script&lang=js"
import style0 from "./SimulationInfo.vue?vue&type=style&index=0&id=1c2f4cb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2f4cb7",
  null
  
)

export default component.exports